import {Model} from "@vuex-orm/core";

export default class WebsiteProductRegion extends Model {

    static entity = 'websiteProductRegion';

    static primaryKey = ['website_product_id', 'region_id'];

    static fields () {
        return {
            website_product_id: this.number(null).nullable(),
            region_id: this.number(null).nullable(),
        }
    }
}
